import './Chassis.css'
import { Screen } from '../screen/Screen'

export const Chassis = () => {
  return (
    <div className='chassis'>
      <h1 className='title'>Human Chooser 4000</h1>
      <Screen />
    </div>
  )
}